<template>
  <div class="liveBox" ref="scrollEle">
    <div class="top">
      <div class="replayBox" v-if="playInfo">
        <CourseVideo :playInfo="playInfo"></CourseVideo>
      </div>
      <div class="live" v-show="!playInfo">
        <div
          v-show="
            info.livestatus == 1001 ||
            (info.livestatus == 1000 && info.advertisingurl)
          "
        >
          <video
            class="video video-js vjs-big-play-centered"
            webkit-playsinline="true"
            playsinline="true"
            ref="video"
            :poster="info.coverimg"
          ></video>
        </div>
        <img
          v-show="
            !(
              info.livestatus == 1001 ||
              (info.livestatus == 1000 && info.advertisingurl)
            )
          "
          :src="info.coverimg"
          alt=""
        />
      </div>
    </div>
    <div class="nav">
      <ul>
        <li :class="navIndex == 0 ? 'active' : ''" @click="switchNav(0)">
          详情
        </li>
        <li :class="navIndex == 1 ? 'active' : ''" @click="switchNav(1)">
          互动
        </li>
      </ul>
    </div>
    <div class="main">
      <swiper ref="mySwiper" :options="swiperOption" class="swiper-wrapper">
        <swiper-slide>
          <div class="detail">
            <div class="timeBox">
              <i class="leftLabel label"></i>
              <i class="rightLabel label"></i>
              <p class="title">{{ info.name }}</p>
              <i class="liveLabel"></i>
              <p class="liveTime" v-if="info">
                {{
                  info.livestatus == 1000
                    ? "距离" + util.changeTime({time:info.starttime,line:'text',showMin:true}) + "开播还有"
                    : "直播时间：" + util.changeTime({time:info.starttime,line:'text',showMin:true})
                }}
              </p>
              <div class="statusBox">
                <div
                  class="countdown"
                  v-if="info.livestatus == 1000"
                >
                  <span>{{ days }}</span>
                  <em>天</em> <span>{{ hours }}</span> <em>时</em>
                  <span>{{ minutes }}</span> <em>分</em>
                  <span>{{ seconds }}</span>
                  <em>秒</em>
                </div>
                <div v-else-if="info.livestatus != 1000">
                  {{
                    info.livestatus == 1001
                      ? "直播中"
                      : info.livestatus == 1003
                      ? "已结束，可回放"
                      : "已结束"
                  }}
                </div>
              </div>
              <div class="opation">
                <p
                  :class="['tip',info.subscribeStatus==1004?'disableBtn':'']"
                  v-if="info.livestatus == 1000&&info.subscribeStatus!=1004"
                  @click="subscribe"
                >
                  <span>{{info.subscribeStatus==1004?'已提醒':'开播提醒'}}</span>
                </p>
                <p class="online">
                  {{
                    util.showCount(info.livestatus==1000?info.reservecount:watchNumber)+'人'+(info.livestatus == 1001 ? " 在线": info.livestatus == 1000? "预约": " 观看")
                  }}
                </p>
              </div>
            </div>
            <div
              class="common teacher"
              v-if="info.teacher && info.teacher.arthome == 'Y'"
              @click="goto('teacher')"
            >
              <div class="commonTop">
                <span>主讲老师</span>
              </div>
              <div class="commonContent">
                <img :src="info.teacher.image" alt="" />
                <div class="info">
                  <p class="name">{{ info.teacher.name }}</p>
                  <p class="title">{{ info.teacher.title }}</p>
                </div>
              </div>
            </div>
            <div class="common introduction">
              <div class="commonTop">
                <span>直播简介</span>
              </div>
              <div class="commonContent" v-html="info.memo"></div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="chatContentBox" v-show="loginStatus">
            <div class="chatBox" ref="chatBox">
              <ul class="clearfix" ref="chatListBox">
                <li
                  v-for="(item, index) in chatBox"
                  :key="index"
                  :class="[item.from == customerid ? 'right' : 'left']"
                >
                  <div class="chatDetail" v-if="item.to == groupID">
                    <div
                      class="img"
                      v-if="item.from != customerid"
                      :style="{
                        'background-image': 'url(' + item.avatar + ')',
                      }"
                    ></div>
                    <div class="content">
                      <div>
                        <p class="name">
                          {{
                            (item.from == ownerAccount ? "直播管理员：" : "") +
                            item.nick
                          }}
                        </p>
                        <div class="messageContent" v-if="item.payload">
                          {{ item.payload.text }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="img"
                      v-if="item.from == customerid"
                      :style="{
                        'background-image': 'url(' + item.avatar + ')',
                      }"
                    ></div>
                  </div>
                  <div class="msgTip" v-if="item.type == 'tip'">
                    请各位遵守国家相关规定，直播中切勿涉及低俗、色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，爱艺术+保有依据国家规定及平台规则进行处理的权利。
                  </div>
                </li>
              </ul>
              <div class="likeBox" v-if="navIndex == 1">
                <div class="like" @click="showLike">
                  <i class="likeOpt"></i>
                </div>
                <p class="likeCount">{{ util.showCount(likeCount) }}</p>
              </div>
            </div>
            <div class="footerBox">
              <div class="sendMsg" v-if="info.chatroom == 'Y'">
                <div class="sendLeft">
                  <form
                    action="/"
                    method="get"
                    enctype="application/json"
                    @submit.prevent="sendMsg"
                  >
                    <input
                      type="text"
                      v-model="message"
                      placeholder="输入你需要提的问题"
                      @mouseup.prevent
                      ref="inputMsg"
                      @blur="onblur"
                    />
                  </form>
                </div>
                <div class="sendRight">
                  <span class="send" @click="sendMsg">发送</span>
                </div>
              </div>
              <div class="mute" v-else>互动禁言</div>
            </div>
          </div>
          <div class="loginBox" v-show="!loginStatus">
            <p>立即登录参与实时互动</p>
            <span @click="util.wechatLogin()">去登录</span>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import TIM from "tim-js-sdk";
require("video.js/dist/video-js.css");
import CourseVideo from "@/components/courseVideo";

export default {
  metaInfo() {
    return {
      title: this.info.name,
    };
  },

  data() {
    return {
      activityId: "",
      info: "",
      navIndex: 0,
      swiperOption: {
        noSwiping: true,
        autoHeight: true,
        onSlideChangeStart: function (swiper) {
          this.navIndex = swiper.activeIndex;
        }.bind(this),
      },

      days: "",
      hours: "",
      minutes: "",
      seconds: "",
      likeCount: 0,
      watchNumber: 0,

      player: "",
      info: "",
      message: "",
      chatBox: [],
      tim: "",
      loginTim: false,
      likes: false,
      activityId: "",
      customerid: "",
      groupID: "",
      nextReqMessageID: {},
      end: false,
      timReady: false,
      userInfo: "",
      likeCount: 0,
      watchNumber: 0,
      clickIndex: 0,
      ownerAccount: "", //群主
      timeStop: "",
      playInfo: "",
      loginStatus: false,
      ScrollHeight: "",
      countdownStop: "",
      endTime: "",
      systemtime: "",
    };
  },
  components: {
    CourseVideo,
  },
  mounted() {
    this.activityId = this.$route.query.activityId?this.$route.query.activityId : "";
    this.loginStatus = this.util.loginStatus();
    this.getLive();
  },
  methods: {
    srollEvent() {
      var _this = this;
      var scroll = _this.$refs.chatBox.scrollTop;
      if (scroll <= 0 && !this.end) {
        this.ScrollHeight = this.$refs.chatBox.scrollHeight;
        if (this.timReady) {
          this.getMessge(1);
        }
      }
    },
    getIm() {
      this.$post("/iart-api-message/im/queryAppid", {}).then((res) => {
        if (res.code == 1) {
          var options = {
            SDKAppID: res.data.appid-0, // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
          };
          // 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
          this.tim = TIM.create(options);
          // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
          this.tim.setLogLevel(0);
          //监听消息回调
          this.login();
          this.onTim();
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    onTim() {
      var _this = this;
      var onKickedOut = function (event) {
        // TIM.TYPES.KICKED_OUT_MULT_ACCOUNT(Web端，同一账号，多页面登录被踢)
        // TIM.TYPES.KICKED_OUT_MULT_DEVICE(同一账号，多端登录被踢)
        // TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED(签名过期。使用前需要将SDK版本升级至v2.4.0或以上)
        if (localStorage.getItem("isWeixin") == 1) {
          this.util.wechatLogin();
        } else {
          window.location.href = "/#/login/login?back=true";
        }
      };
      this.tim.on(TIM.EVENT.KICKED_OUT, onKickedOut);
      var onMessageReceived = function (event) {
        var ele = _this.$refs.chatBox;
        //判断元素是否出现了滚动条
        if (ele && event.data[0].from != "@TIM#SYSTEM") {
          if (ele.scrollHeight == ele.scrollTop + ele.clientHeight) {
            //设置滚动条到最底部
            _this.chatBox = _this.chatBox.concat(event.data);
            ele = _this.$refs.chatBox;
            setTimeout(() => {
              if (ele.scrollHeight > ele.clientHeight) {
                //设置滚动条到最底部
                ele.scrollTop = ele.scrollHeight;
              }
            }, 200);
          } else {
            _this.chatBox = _this.chatBox.concat(event.data);
          }
        }

        // event.data - 存储 Message 对象的数组 - [Message]
      };
      this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, onMessageReceived);
      var onSdkReady = function (event) {
        _this.timReady = true;
        _this.getMessge();
      };
      this.tim.on(TIM.EVENT.SDK_READY, onSdkReady);
    },
    getLive() {
      var _this = this;
      this.$post("iart-api-scm/api/scm/activity/queryLiveActivity", {
        activityId: this.activityId,
      }).then((res) => {
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            _this.info = res.data;
            this.groupID = res.data.groupid;
            this.ownerAccount = res.data.ownerAccount;
            this.getlike();
            // this.switchNav(0);
          
            if (this.loginStatus) {
              this.getIm();
              this.$refs.chatBox.addEventListener("scroll", this.srollEvent);
            }
            if (res.data && res.data.livestatus == 1000) {
            if (res.data.starttime >= res.systemtime) {
                this.countdownStop = true;
                this.showCountdown(res.systemtime, res.data.starttime);
                this.countdown(res.systemtime, res.data.starttime);
              } else {
                clearInterval(this.infoTime);
                clearInterval(this.timeStop);
              }
              if (res.data.advertisingurl) {
                this.showLive(res.data.advertisingurl);
              }
            }
            if (res.data && res.data.livestatus == 1001) {
              if (res.data && res.data.rtmpplayurl) {
                this.showLive(res.data.rtmpplayurl);
              } else {
                this.showLive(res.data.livepayurl);
              }
                this.timeStop = setInterval(function () {
              _this.getlike();
            }, 10000);
            } else if (res.data && res.data.livestatus == 1003) {
              if (res.data && res.data.video) {
                this.playInfo = res.data.video;
              } else {
                this.util.toast({ msg: "暂无回放内容" });
              }
            } else if (res.data && res.data.livestatus == 1002) {
              this.showLive(res.data.advertisingurl);
            } else {
              this.showLive(res.data.advertisingurl);
            }
            this.shareLink();
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      });
    },
     showCountdown(startTime, endTime) {
      var time = parseInt(endTime - startTime);
      var days = Math.floor(time / (1000 * 60 * 60 * 24));
      var hours = Math.floor((time / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((time / (1000 * 60)) % 60);
      var seconds = Math.floor((time / 1000) % 60);
      this.days = days >= 10 ? days : "0" + days;
      this.hours = hours >= 10 ? hours : "0" + hours;
      this.seconds = seconds >= 10 ? seconds : "0" + seconds;
      this.minutes = minutes >= 10 ? minutes : "0" + minutes;
    },
    countdown(startTime, endTime) {
      var _this = this;
      this.timeStop = setInterval(function () {
        if (endTime < startTime) {
          _this.getLive();
        }
        startTime += 1000;
        _this.showCountdown(startTime, endTime);
      }, 1000);
    },
    showLive(url) {
      var _this = this;
      this.player = videojs(_this.$refs.video, {
        loop: false,
        controls: true, //是否显示空间
        autoplay: true, //自动播放
        preload: "auto", //播放器加载完是否下载视频 （auto）浏览器支持即会下载  （metadata）仅加载视频元数据 （none）用户点击播放下载视频
        liveui: true,
        sources: [
          {
            src: url,
          },
        ],
        poster: "", //封面图
      });
    },
    getMessge(type) {
      var _this = this;
      if (type && _this.nextReqMessageID) {
        var nextReqMessageID = _this.nextReqMessageID;
        var promise = this.tim.getMessageList({
          conversationID: "GROUP" + this.groupID,
          nextReqMessageID,
          count: 15,
        });
      } else {
        var promise = this.tim.getMessageList({
          conversationID: "GROUP" + this.groupID,
          count: 15,
        });
      }
      promise.then(function (imResponse) {
        var messageList = imResponse.data.messageList; // 消息列表。
        _this.nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
        var isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
        if (type && _this.nextReqMessageID) {
          _this.chatBox = messageList.concat(_this.chatBox);
          _this.end = isCompleted;
        } else {
          messageList.push({ type: "tip" });
          _this.chatBox = _this.chatBox.concat(messageList);
        }
        // if (messageList.length < 15) {
        // }
        if (!(type && _this.nextReqMessageID)) {
          setTimeout(() => {
            var ele = _this.$refs.chatBox;
            //判断元素是否出现了滚动条
            if (ele.scrollHeight > ele.clientHeight) {
              //设置滚动条到最底部
              ele.scrollTop = ele.scrollHeight;
            }
          }, 200);
        } else {
          setTimeout(() => {
            var ele2 = _this.$refs.chatListBox;
            _this.$refs.chatBox.scrollTop =
              ele2.clientHeight - _this.ScrollHeight;
          });
        }
      });
    },
    login() {
      var _this = this;
      if (!this.util.loginStatus()) {
        return false;
      } else {
        this.$post("iart-api-crm/api/crm/customer/query").then((res) => {
          if (!this.util.processingData(res)) {
            return false;
          }
          _this.userInfo = res.data;
          _this.customerid = res.data.customerid;
          this.$post("iart-api-message/im/userSig", {
            customerid: res.data.customerid,
          }).then((res1) => {
            if (res1.code == 1) {
              var data = res1.data;
              if (res1.code == 1) {
                var promise = _this.tim.login({
                  userID: res1.data.customerid,
                  userSig: res1.data.sign,
                });
                promise
                  .then(function (imResponse) {
                    console.log(imResponse, "登录成功"); // 登录成功
                    _this.loginTim = true;
                    var promise1 = _this.tim.joinGroup({
                      groupID: _this.groupID,
                      //type: TIM.TYPES.GRP_CHATROOM
                    });
                    promise1
                      .then(function (imResponse1) {
                        switch (imResponse1.data.status) {
                          case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意
                            break;
                          case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
                            _this.synchronizeInfo();
                            console.log(imResponse1.data.group, "加群"); // 加入的群组资料
                            break;
                          case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
                            console.log("已在群中"); // 加入的群组资料
                            break;
                          default:
                            break;
                        }
                      })
                      .catch(function (imError) {
                        console.warn("joinGroup error:", imError); // 申请加群失败的相关信息
                      });
                  })
                  .catch(function (imError) {
                    _this.loginTim = false;
                    // console.warn("login error:", imError); // 登录失败的相关信息
                  });
              }
            }
          });
        });
      }
    },
    synchronizeInfo() {
      this.$post("iart-api-message/im/accountImport", {
        customerid: this.userInfo.customerid,
      }).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            console.log("信息同步成功");
          } else {
            console.log("信息同步失败", res.data.rtncode);
          }
        } else {
          console.log("信息同步失败", res.code);
        }
      });
    },
    showMessage() {
      if (this.info.livestatus == 1001 && this.info.rtmpplayurl) {
        var _this = this;
        this.send = true;
        setTimeout(function () {
          _this.$refs.inputMsg.focus(); //针对于pc端显示问题
        });
      }
    },
    sendMsg() {
      var _this = this;
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      } else {
        if (this.loginTim) {
          if (this.message.trim().length > 0) {
            var _this = this;
            //创建消息
            var message = this.tim.createTextMessage({
              to: _this.groupID,
              conversationType: TIM.TYPES.CONV_GROUP,
              payload: {
                text: _this.message,
              },
            });
            //发送消息
            var promise = this.tim.sendMessage(message);
            promise
              .then(function (imResponse) {
                // 发送成功
                _this.send = false;
                _this.message = "";
                var message = imResponse.data.message;
                message.avatar = _this.userInfo.headerimg;
                message.nick = _this.userInfo.nickname;
                _this.chatBox.push(message);
                setTimeout(() => {
                  var ele = _this.$refs.chatBox;
                  //判断元素是否出现了滚动条
                  if (ele.scrollHeight > ele.clientHeight) {
                    //设置滚动条到最底部
                    ele.scrollTop = ele.scrollHeight;
                  }
                }, 200);
              })
              .catch(function (imError) {
                // 发送失败
                if (JSON.stringify(imError).indexOf("beat word") != -1) {
                  _this.util.toast({ msg: "评论涉及敏感词" });
                } else if (imError.code == 10017) {
                  _this.util.toast({ msg: "您已被禁言" });
                } else {
                  _this.util.toast({ msg: JSON.stringify(imError) });
                }
              });
          } else {
          }
        } else {
          this.util.loginAgain();
        }
      }
    },
    shareLink() {
      var _this = this;
      var url =
        _this.$store.state.state.shareUrl +
        "/h5/course/live?activityId=" +_this.activityId;
      var data = {
        title: this.info.sharetitle,
        desc: this.info.sharesummary ? this.info.sharesummary : "",
        // url: url,
        imgUrl: this.info.shareicon,
      };
      this.util.shareLink( data).then(function () {
      });
    },
    showLike() {
      this.clickIndex++;
      var style = document.createElement("style");
      var timestamp = new Date().valueOf();
      style.type = "text/css";
      style.id = this.clickIndex;
      var keyFrames = "";
      var div = "";
      for (let i = 0; i < 3; i++) {
        keyFrames +=
          "\
            @-webkit-keyframes " +
          "animation" +
          i +
          "{\
            0% {\
            left: " +
          parseInt(Math.random(0, 1) * 100) +
          "%;\
            bottom: 0;\
            opacity: 1;\
            }\
            25% {\
            left:" +
          parseInt(Math.random(0, 1) * 100) +
          "%;\
            bottom: " +
          parseInt(Math.random(0, 1) * (25 - 1) + 1) +
          "%;\
            opacity: .8;\
            }\
            50% {\
            left:" +
          parseInt(Math.random(0, 1) * 100) +
          "%;\
            bottom: " +
          parseInt(Math.random(0, 1) * (75 - 51) + 50) +
          "%;\
            opacity: .5;\
            }\
            100% {\
                left: " +
          parseInt(Math.random(0, 1) * 100) +
          "%;\
                bottom: 100%;\
                opacity: 0;\
            }\
        }";
        var divClassName = "." + timestamp;
        div +=
          '<div class="heartBox ' +
          timestamp +
          " " +
          this.clickIndex +
          '" style="position: absolute;top: -80px;left: 0; right: 0;width: 80%;height: 80px;"><i style="animation:' +
          "animation" +
          i +
          " 1s linear;  display: inline-block; width: 23px;height: 20px;background: url(" +
          require("../../../assets/img/h5/heart.png") +
          ') no-repeat;background-size: 23px 20px;position: absolute;left: 10%; bottom: -20px;opacity: 1;"></i></div>';
      }
      style.innerHTML = keyFrames;
      $(style).appendTo("head");
      $(div).appendTo(".like");
      this.likeCountOpt(1);
      this.clearAll(this.clickIndex);
    },
    getlike() {
      var _this = this;
      _this.$post("/iart-api-scm/api/scm/activity/queryActivityWatch", {
          liveactivityid: _this.info.liveactivityid,
        })
        .then((res) => {
          _this.watchNumber =
            res.data && res.data.totalwatchnumber
              ? res.data.totalwatchnumber
              : 0;
          _this.likeCount =
            res.data && res.data.toallikenumber ? res.data.toallikenumber : 0;
        });
    },
    clearAll(clickIndex) {
      setTimeout(function () {
        $("#" + clickIndex).remove();
        $("." + clickIndex).remove();
      }, 900);
    },
    likeCountOpt(type) {
      var obj = {
        liveactivityid: this.info.liveactivityid,
      };
      if (type == 1) {
        obj.likenumber = 1;
      } else {
        obj.watchnumber = 1;
      }
      this.$post("/iart-api-scm/api/scm/activity/liveLike", obj).then((res) => {
        if (res.code == 1) {
          this.likeCount = res.data.likenumber;
          // this.watchNumber = res.data.watchnumber;
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    subscribe() {
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
      } else {
        if (this.info.subscribeStatus != 1004) {
          var obj = {
            messagetype: 1090,
            targettype: 1005,
            message: this.info.name,
            businessid: this.activityId,
            informationtype: 1001,
          };
          this.$post(
            "iart-api-crm/api/crm/custservice/createBySubscribeMessage",
            obj
          ).then((res) => {
            if (res.code == 1) {
              this.info.subscribeStatus != 1004? (this.info.subscribeStatus = 1004): "";
              this.info.reservecount++;
              this.util.toast({ msg: "已订阅该直播" });
            } else {
              this.util.toast({ msg: res.message });
            }
          });
        } else {
          this.util.toast({ msg: "已订阅该直播" });
        }
      }
    },
    switchNav(index) {
      this.navIndex = index;
      this.$refs.mySwiper.swiper.slideTo(index, 200, false);
    },
    goto(type) {
      switch (type) {
        case "teacher":
          this.$router.push({
            path: "/h5/course/artHome/artHome",
            query: { teacherId: this.info.teacherid },
          });
          break;

        default:
          break;
      }
    },
    onblur() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.liveBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #f4f4f7;
  display: flex;
  flex-direction: column;
  .top {
    width: 100%;
    height: 31vh;
    background: #000;
    .live {
      width: 100%;
      height: 31vh;
      .video {
        width: 100%;
        height: 100%;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      > div {
        width: 100%;
        height: 100%;
      }
    }
    .replayBox {
      width: 100%;
      height: 31vh;
      .video {
        width: 100%;
        height: 100%;
      }
    }
  }
  .nav {
    background: #fff;
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      li {
        padding: 16px 0;
        font-size: 14px;
        line-height: 24px;
        color: rgba(45, 45, 45, 0.4);
        font-weight: 500;
      }
      li.active {
        color: rgba(45, 45, 45, 1);
        font-weight: bolder;
        position: relative;
      }
      li.active::before {
        content: " ";
        display: inline-block;
        width: 18px;
        height: 2px;
        position: absolute;
        left: 50%;
        margin-left: -9px;
        bottom: 0;
        background: rgba(49, 33, 45, 1);
      }
    }
  }
  .main {
    flex: 1;
    overflow: auto;
    .swiper-wrapper {
      height: 100%;
      width: 100%;
      /deep/ .swiper-slide {
        height: 100%;
        width: 100%;
        overflow: auto;
      }
    }
    .detail {
      margin: 16px;
      .timeBox {
        background: #fff;
        box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.06);
        padding: 35px 12px 24px;
        position: relative;
        text-align: center;
        .label {
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: RGBA(237, 237, 240, 1);
          position: absolute;
          top: 4px;
        }
        .label::before {
          content: " ";
          display: inline-block;
          width: 8px;
          height: 16px;
          border-radius: 4px;
          background: #ccccd2;
          position: absolute;
          top: -10px;
          left: 50%;
          margin-left: -4px;
        }
        .leftLabel {
          left: 108px;
        }
        .rightLabel {
          right: 108px;
        }
        .title {
          font-size: 18px;
          line-height: 25px;
          color: #343737;
          font-weight: bolder;
        }
        .liveLabel {
          display: inline-block;
          margin: 24px 0;
          width: 56px;
          height: 26px;
          background: url(../../../assets/img/h5/live.png) no-repeat;
          background-size: 56px 26px;
        }
        .liveTime {
          color: rgba(45, 45, 45, 0.4);
          font-size: 12px;
          line-height: 15px;
          font-weight: 400;
        }
        .statusBox {
          font-size: 22px;
          line-height: 30px;
          div {
            margin-top: 16px;
          }
          .countdown {
            margin-top: 4px;
          }
          span {
            font-size: 36px;
            line-height: 46px;
            color: rgba(45, 45, 45, 1);
            font-weight: bold;
            text-align: center;
            display: inline-block;
          }
          em {
            font-size: 11px;
            line-height: 16px;
            color: rgba(52, 55, 55, 0.4);
          }
          em:not(:last-child) {
            margin-right: 9px;
          }
        }
        .opation {
          .tip {
            padding: 16px 0 0;
            border-top: 0.5px dashed rgba(212, 212, 212, 1);
            margin-top: 16px;
            span {
              display: block;
              margin: 0 32px;
              background: rgba(201, 55, 61, 1);
              border-radius: 3px;
              font-size: 14px;
              line-height: 21px;
              color: rgba(255, 255, 255, 1);
              padding: 12px 0;
              text-align: center;
            }
          }
          .online {
            padding: 0 32px;
            color: rgba(45, 45, 45, 0.4);
            font-size: 12px;
            line-height: 17px;
            margin-top: 16px;
          }
        }
      }
      .common {
        margin-top: 24px;
        .commonTop {
          position: relative;
          span {
            font-size: 14px;
            line-height: 20px;
            color: rgba(45, 45, 45, 0.6);
            position: relative;
            z-index: 10;
            background: rgba(244, 244, 247, 1);
            padding-right: 8px;
            font-weight: bolder;
          }
        }
        .commonTop::before {
          content: " ";
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 1px;
          background: rgba(224, 224, 224, 1);
          z-index: -1;
        }
        .commonContent {
          margin-top: 20px;
          background: #fff;
          border-radius: 3px;
        }
      }
      .teacher .commonContent {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 24px;
        img {
          width: 68px;
          height: 68px;
          border-radius: 50%;
          object-fit: cover;
        }
        .info {
          flex: 1;
          overflow: hidden;
          margin-left: 16px;
          position: relative;
          padding-right: 30px;
          p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .name {
            font-size: 16px;
            line-height: 22px;
            color: rgba(45, 45, 45, 1);
          }
          .title {
            font-size: 12px;
            line-height: 17px;
            color: rgba(45, 45, 45, 0.6);
            margin-top: 3px;
          }
        }
        .info::before {
          content: " ";
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../../../assets/img/h5/arrow_r_darkgray.png) no-repeat;
          background-size: 24px 24px;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -12px;
        }
      }
      .introduction .commonContent {
        overflow-x: hidden;
        padding: 24px;
        img,
        image {
          max-width: 100%;
        }
      }
    }
    .chatContentBox {
      height: 100%;
      display: flex;
      flex-direction: column;
      .chatBox {
        flex: 1;
        overflow: auto;
        padding: 12px 15px;
        li {
          width: 100%;
          .msgTip {
            font-size: 12px;
            line-height: 17px;
            color: rgba(45, 45, 45, 0.6);
            padding: 16px;
            background: rgba(45, 45, 45, 0.05);
            border-radius: 3px;
          }
          .chatDetail {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            .img {
              display: inline-block;
              width: 32px;
              height: 32px;
              border-radius: 50%;
              background-position: center center;
              background-repeat: no-repeat;
              background-size: cover;
              margin-bottom: 4px;
            }
            .content {
              flex: 1;
              overflow: hidden;
              > div {
                width: 100%;
              }
              .name {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 10px;
                line-height: 14px;
                color: rgba(45, 45, 45, 0.8);
              }
              .messageContent {
                margin-top: 5px;
                display: inline-block;
                overflow: hidden;
                font-size: 13px;
                line-height: 20px;
                color: rgba(45, 45, 45, 1);
                border-radius: 8px 8px 8px 2px;
                background: #ffffff;
                padding: 12px;
                word-break: break-all;
              }
            }
          }
        }

        li:not(:last-child) {
          margin-bottom: 16px;
        }
        .left {
          .chatDetail {
            .content > div {
              text-align: left;
            }
          }
          .img {
            margin-right: 8px;
          }
        }
        .right {
          .img {
            margin-left: 8px;
          }
          .chatDetail {
            .content > div {
              text-align: right;
              .messageContent {
                border-radius: 8px 8px 2px 8px;
                background: rgba(127, 134, 152, 1);
                color: #fff;
              }
            }
          }
        }
        .likeBox {
          display: inline-block;
          position: absolute;
          right: 16px;
          bottom: 74px;
          z-index: 99;
          .like {
            > i {
              display: inline-block;
              width: 49px;
              height: 49px;
              background: url(../../../assets/img/h5/like1.png) no-repeat;
              background-size: 49px 49px;
            }
          }
          .likeCount {
            font-size: 13px;
            line-height: 19px;
            color: #333333;
            margin-top: -4px;
            text-align: center;
          }
        }
      }
      .footerBox {
        padding: 8px 16px;
        background: #fff;
        box-shadow: 0 1px 30px 10px rgba(0, 0, 0, 0.03);
        width: 100%;
        overflow: hidden;
        .sendMsg {
          display: flex;
          flex-direction: row;
          align-items: center;
          .sendLeft {
            flex: 1;
            input {
              width: 100%;
              font-size: 14px;
              line-height: 20px;
              padding: 8px 12px;
              border-radius: 24px;
              overflow: hidden;
              color: rgba(45, 45, 45, 1);
              background: #f5f6f8;
              font-weight: 400;
            }
            input::placeholder {
              color: rgba(45, 45, 45, 0.3);
              font-size: 14px;
              line-height: 20px;
              font-weight: 400;
            }
          }
          .sendRight {
            margin-left: 12px;
            .send {
              font-size: 14px;
              line-height: 20px;
              color: #fff;
              cursor: pointer;
              display: inline-block;
              padding: 8px 16px;
              border-radius: 19px;
              text-align: center;
              background: #f62625;
            }
          }
        }
        .mute {
          font-size: 14px;
          line-height: 20px;
          padding: 14px;
          color: rgba(45, 45, 45, 0.3);
          text-align: center;
        }
      }
    }
    .loginBox {
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #f4f4f7;
      padding-top: 50px;
      p {
        font-size: 16px;
        line-height: 22px;
        color: rgba(45, 45, 45, 0.4);
        font-weight: 400;
      }
      span {
        display: inline-block;
        background: rgba(201, 55, 61, 1);
        color: #fff;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        text-align: center;
        border-radius: 6px;
        padding: 12px 32px;
        margin-top: 24px;
      }
    }
  }
}
</style>